import { useTheme } from '@mui/material';
import cn from 'classnames';
import * as React from 'react';

import { useWL } from '../../../contexts/ThemeProvider';
import useWindowSize from '../../../hooks/useWindowSize';
import { DrawerAnimationDirectionEnum } from '../../../types/shell';
import Drawer from '../../Drawer/Drawer';
import { Nav, NavHeader, NavToggle } from '../index';

import styles from './DesktopSidenav.module.scss';

interface IProps {
  expanded: boolean;
  toggle: () => void;
  mainMenu: React.ReactNode | React.ReactNode[];
}

const DesktopSidenav = ({ expanded, toggle, mainMenu }: IProps) => {
  const { sass: variables } = useTheme();
  const { HD } = useWindowSize();
  const theme = useWL();

  const hasPoweredBy = React.useMemo(() => {
    return !!theme?.org_rect_logo;
  }, [theme?.org_rect_logo]);

  return (
    <Drawer
      direction={DrawerAnimationDirectionEnum.Horizontally}
      from={HD ? variables.navDesktopMinWidthHD : variables.navDesktopMinWidth}
      to={variables.navDesktopMaxWidth}
      className={styles.desktopSideNav}
      trigger={expanded}
      onClose={toggle}
      overlayClassName={styles.overlay}
    >
      <div className={styles.bodyContainer}>
        <NavHeader expanded={expanded} />
        <NavToggle expanded={expanded} onClick={toggle} style={{ padding: 2, marginTop: hasPoweredBy ? 5 : 1 }} />
        <div className={cn(styles.body)}>
          <Nav>{mainMenu}</Nav>
        </div>
      </div>
    </Drawer>
  );
};

export default DesktopSidenav;
